import { useRef, useEffect } from "react";
import { Icons } from "../../constants/icon-library";

const TaskEditForm = ({
  editedTaskName,
  editedTaskDescription,
  onTaskNameChange,
  onDescriptionChange,
  onSave,
  onCancel,
  onKeyDown,
  action,
  onDeleteTask,
}) => {
  const taskNameInputRef = useRef();

  useEffect(() => {
    if (taskNameInputRef.current) {
      taskNameInputRef.current.focus();
      taskNameInputRef.current.select();
    }
  }, []);

  return (
    <div>
      <input
        ref={taskNameInputRef}
        type="text"
        className="form-control form-control-sm mb-2"
        value={editedTaskName}
        onChange={(e) => onTaskNameChange(e.target.value)}
        onKeyDown={(e) => onKeyDown(e, action)}
        placeholder="Task name"
      />
      <textarea
        className="form-control form-control-sm mb-2"
        rows="3"
        value={editedTaskDescription}
        onChange={(e) => onDescriptionChange(e.target.value)}
        onKeyDown={(e) => onKeyDown(e, action)}
        placeholder="Task description"
      />
      <div className="d-flex justify-content-between align-items-center px-2 mb-1">
        {/* LEFT — Cancel */}
        <button
          className="btn btn-outline-danger btn-sm d-flex align-items-center gap-2"
          onClick={onCancel}
        >
          Cancel
        </button>

        {/* RIGHT — Delete + Save */}
        <div className="d-flex align-items-center gap-2 ">
          <button
            className="btn btn-sm btn-phoenix-danger "
            onClick={() => onDeleteTask(action)}
            title="Delete task"
          >
            <i className={`wb ${Icons("remove")} align-middle pe-1`} />
            Delete
          </button>
          <button
            className="btn btn-primary btn-sm d-flex align-items-center gap-2"
            onClick={() => onSave(action)}
            disabled={
              !editedTaskName.trim() || editedTaskDescription.trim().length < 10
            }
          >
            <i className={`wb ${Icons("save")} align-middle pe-1`} />
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default TaskEditForm;
